import { createSelector } from 'reselect';
import get from '../helpers/get';
import { getSlices } from './content';

const isBusy = (state, prop) => get(state, ['greenhouse', prop, 'busy']);
const getError = (state, prop) => get(state, ['greenhouse', prop, 'error']);

export const isJobsBusy = state => isBusy(state, 'jobs') || false;
export const getJobsError = state => getError(state, 'jobs');
export const isJobsReadyOrError = state => !isJobsBusy(state)
|| !!getJobsError(state);

export const greenhouseFilters = state => ({
  departmentId: get(state, ['greenhouse', 'filters', 'departmentId']) || 0,
  officeId: get(state, ['greenhouse', 'filters', 'officeId']) || 0,
});

export const getGreenhouseTray = createSelector(
  getSlices,
  slices => slices.find(slice => slice.type === 'greenhouse_job_board'),
);
